var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatteryAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 124 124",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1376,-149)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,199.71,-1682.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "batteryAlt",
    transform: "matrix(0.818222,0,0,0.818222,247.447,118.734)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.953173,0,0,0.535047,634.971,344.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 529.35,
    cy: 1399.56,
    r: 75.164,
    style: {
      fill: "rgb(0,177,92)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.39926,0,0,0.78545,-557.798,737.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1230.16,431.987L1220.36,431.987L1220.08,424.361L1206.79,424.21L1206.73,431.987L1195.88,431.987L1195.88,481.666L1230.16,481.666L1230.16,431.987Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "3.33px"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryAlt);
export default __webpack_public_path__ + "static/media/batteryAlt.5536320b3986019c40414b9bca9e62bb.svg";
export { ForwardRef as ReactComponent };